import { FC, ReactNode } from 'react';
import { Neon } from '../neon';

type ProjectDetailsPageTemplateTypes = {
  documentTitle: string;
  title: ReactNode;
  breadCrumbs?: ReactNode;
  tabs?: ReactNode;
  subText?: ReactNode;
};

export const ProjectDetailsPageTemplate: FC<
  React.PropsWithChildren<ProjectDetailsPageTemplateTypes>
> = ({ documentTitle, title, tabs, children }) => (
  <Neon
    documentTitle={documentTitle}
    title={title}
    tabs={tabs}
    actions={{}}
    content={children}
    $island
  />
);
